import { Dialog as RadixDialog } from 'radix-ui';
import { useTranslation } from 'react-i18next';
import { VariantsPanel } from '../../widgets/variants-panel';

/** Small screens: the variants tree as a sheet from the left. */
export function VariantsDrawer({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 animate-fade-in bg-overlay" />
        <RadixDialog.Content
          aria-describedby={undefined}
          // Focus the sheet itself: focusing its first button would pop that button's tooltip,
          // and the first Escape would only close the tooltip.
          onOpenAutoFocus={(event) => {
            event.preventDefault();
            (event.currentTarget as HTMLElement | null)?.focus();
          }}
          className="fixed inset-y-0 left-0 z-50 flex w-[min(320px,85vw)] flex-col bg-bg-1 shadow-popover outline-none"
        >
          <RadixDialog.Title className="sr-only">{t('variants.title')}</RadixDialog.Title>
          <VariantsPanel />
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
